export const otherCalculators = [
  {
    name: "مولد كلمة السر",
    link: "/calculator/ar/random-password-generator/",
    description:
      "مولد كلمة المرور، كلمات مرور قوية، حماية الحسابات، تأمين البيانات، أمان الإنترنت، مولد كلمة مرور عشوائي، أحرف وأرقام ورموز، تأمين الحسابات الشخصية، إنشاء كلمة مرور قوية",
    showMain: true,
  },
  {
    name: "مولد الأسماء ",
    link: "/calculator/ar/random-name-generator/",
    description:
      "استخدم مولد الأسماء لاكتشاف تشكيلة واسعة من الأسماء الفريدة والجميلة. سواء كنت تبحث عن أسماء عربية، غربية، إسلامية، شرقية، فاخرة، أو نادرة، يقدم لك هذا المولد خيارات متنوعة للعثور على الاسم المثالي لمولدك الجديد!",
    showMain: true,
  },
  {
    name: "قياس سرعة الانترنت ",
    link: "/calculator/ar/internet-speed/",
    description:
      "قياس سرعة الانترنت، اختبار سرعة الانترنت، قياس سرعة الانترنت الحقيقية، اختبار سرعة الانترنت الحقيقية، اختبار سرعة الانترنت الفعلية، قياس سرعة الانترنت الفعلية، اختبار سرعة الانترنت الحقيقية على الانترنت، قياس سرعة الانترنت الحقيقية على الانترنت",
    showMain: true,
  },
  {
    name: " مولد رقم عشوائي",
    link: "/calculator/ar/random-number-generator/",
    description:
      "مولد الأرقام العشوائية هة أداة تساعدك في توليد أرقام ضمن نطاق محدد تقوم بتعيينه ويمكنك اختيار الحد الأدنى والأعلى للنطاق، وتحديد عدد الأرقام العشوائية التي ترغب في توليدها. ",
    showMain: true,
  },
  {
    name: "زخرفة نص",
    link: "/calculator/ar/text-decorator/",
    description:
      "حول النص العادي إلى شيء مميز. أضف الألوان والأنماط والخطوط المفضلة لديك لنصك. مثالي لمنشورات التواصل الاجتماعي، العناوين، أو مجرد إضافة لمسة شخصية.",
    showMain: true,
  },
  {
    name: "حاسبة الاستغفار - المسبحة الالكترونية",
    link: "/calculator/ar/tally-counter/",
    description:
      "اطلب المغفرة بسهولة ويسر من خلال هاتفك المحمول. اجعل الاستغفار عادةً لك ليعزّ عليك الله ويرحمك.",
    showMain: true,
  },
  {
    name: "حساب الوقت اللازم لتعلم اللغة الانجليزيه",
    link: "/calculator/ar/english-learning-time-calculator/",
    description:
      "استخدم حاسبة الوقت لدينا لتحديد المدة الزمنية الدقيقة التي تحتاجها للوصول إلى مختلف مستويات اللغة الإنجليزية، بدءًا من المبتدئ (A1) حتى المتقدم (C2). بفضل هذه الأداة، يمكنك الحصول على تقدير مخصص للوقت بناءً على مستوى التزامك، سرعة تعلمك، والعوامل الشخصية الأخرى. استفد من هذه الحاسبة لتخطيط دراستك وتحقيق أهدافك اللغوية بفعالية، مع مراعاة أن الأرقام المقدمة تعتمد على بيانات جامعة كامبريدج الخاصة بتقدير الساعات المطلوبة.",
  },
  {
    name: "حاسبة وقت تشغيل البطارية - حساب عدد ساعات عمل البطارية",
    link: "/calculator/ar/battery-life-calculator/",
    description:
      "احسب وقت تشغيل بطارية جهاز معين بناءً على سعة البطارية وسحب التيار للجهاز. تساعدك هذه الحاسبة في معرفة مدة التشغيل التي يمكنك الحصول عليها من بطارية معينة.",
  },
  {
    name: "حاسبة فرق الطول بين شخصين",
    link: "/calculator/ar/height-difference-calculator/",
    description:
      "احسب فرق الطول بين شخصين باستخدام هذه الحاسبة السهلة. تساعدك هذه الأداة في معرفة الفرق الدقيق في الطول بين شخصين عند إدخال أطوالهم.",
  },
  {
    name: "عداد الكلمات - احسب عدد الكلمات في نص",
    link: "/calculator/ar/word-counter/",
    description:
      "احسب عدد الكلمات في جملة معينة باستخدام هذه الحاسبة البسيطة. توفر هذه الحاسبة وسيلة سريعة ودقيقة لمعرفة عدد الكلمات في أي نص تكتبه.",
  },
  {
    name: "تفقيط العملات",
    link: "/calculator/ar/currency-spreader/",
    description:
      "احسب قيمة مبلغ معين بعملتك المفضلة. تساعدك هذه الحاسبة في معرفة قيمة المبلغ بالعملة التي تختارها.",
  },
  {
    name: "حاسبات متخصصة بالدول المختلفة",
    link: "/calculator/ar/countries/",
    description: "تعرف على مختلف الحاسبات المتعلقة بالدول المختلفة",
    showMain: true,
  },
  {
    name: "حساب الوقت اللازم لتعلم اللغة الألمانية",
    link: "/calculator/ar/german-learning-time-calculator/",
    description:
      "اكتشف كم من الوقت قد يستغرق تعلم اللغة الألمانية بناءً على المستوى الذي تريد الوصول إليه.",
  },
  {
    name: "حساب الوقت اللازم لتعلم اللغة الفرنسية",
    link: "/calculator/ar/french-learning-time-calculator/",
    description:
      "اكتشف كم من الوقت قد يستغرق تعلم اللغة الفرنسية بناءً على المستوى الذي تريد الوصول إليه.",
  },
  {
    name: "حساب ساعات الغياب للطالب الجامعي",
    link: "/calculator/ar/absence-calculator/",
    description:
      "اكتشف كم من الوقت قد يستغرق تعلم اللغة الفرنسية بناءً على المستوى الذي تريد الوصول إليه.",
  },
  {
    name: "مؤقت الوقت الإلكتروني - عدّاد تنازلي - مؤقت الإنترنت",
    link: "/calculator/ar/timer/",
    description:
      "استخدم مؤقت الوقت الإلكتروني لضبط الوقت بسهولة. يمكنك استخدامه كمؤقت تنازلي أو عدّاد تصاعدي. مثالي للطبخ، التمارين الرياضية، الدراسة، أو أي نشاط يحتاج إلى توقيت دقيق.",
  },


];
export default otherCalculators;